// CustomSelectFilter.tsx
import type { IFilterParams, IFilterComp } from "ag-grid-community";

// 获取翻译函数 - 使用全局翻译函数，避免在类组件中使用 Hook
const getTranslation = () => {
  // 使用全局 window.__t 函数，由 I18nProvider 设置
  return (window as any).__t || ((key: string) => key);
};

export class CustomTypeFilterComponent implements IFilterComp {
  private eGui: HTMLElement | null = null;
  private selectedType: string | null = null;
  private filterParams: IFilterParams | null = null;
  private uniqueTypes: string[] = ["PDF", "MD", "HTML"]; // 写死三个类型
  private isInitialized: boolean = false;
  private t: any;

  init(params: IFilterParams): void {
    this.filterParams = params;
    // 初始化翻译函数
    this.t = getTranslation();
    this.setupGui();
    this.isInitialized = true;
  }

  setupGui(): void {
    this.eGui = document.createElement("div");
    this.eGui.innerHTML = `
            <div style="padding: 8px; min-width: 100px; max-height: 300px; overflow-y: auto;">
                <div style="margin-bottom: 8px;">
                    <label style="display: flex; align-items: center; cursor: pointer;">
                        <input type="radio" name="type-filter" value="" style="margin-right: 8px;" checked />
                        <span>${this.t("common.all")}</span>
                    </label>
                </div>
                <div style="border-top: 1px solid #e0e0e0; padding-top: 8px;" id="type-list">
                    ${this.uniqueTypes
                      .map(
                        (type) => `
                        <div style="margin-bottom: 6px;">
                            <label style="display: flex; align-items: center; cursor: pointer;">
                                <input type="radio" name="type-filter" value="${type}" style="margin-right: 8px;" />
                                <span>${type}</span>
                            </label>
                        </div>
                    `
                      )
                      .join("")}
                </div>
            </div>
        `;

    // 绑定事件
    const radios = this.eGui.querySelectorAll('input[type="radio"][name="type-filter"]');
    radios.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        const target = e.target as HTMLInputElement;
        const value = target.value;
        this.handleTypeChange(value || null);
      });
    });

    // 设置默认选中状态
    this.selectedType = "";
  }

  handleTypeChange(type: string | null): void {
    // 只有在初始化完成后才处理状态变化
    if (!this.isInitialized) {
      return;
    }

    this.selectedType = type;
    this.filterParams?.filterChangedCallback();

    // 触发父组件刷新
    this.triggerParentRefresh();
  }

  triggerParentRefresh(): void {
    // 确保只传递有效的值
    let valueToSend: string | undefined = undefined;

    if (this.selectedType && this.selectedType !== "") {
      valueToSend = this.selectedType; // 传递实际选中的值
    }

    // 通过全局事件触发父组件刷新
    const event = new CustomEvent("filterChanged", {
      detail: {
        field: "type",
        value: valueToSend,
      },
    });
    window.dispatchEvent(event);
  }

  getGui(): HTMLElement {
    return this.eGui as HTMLElement;
  }

  isFilterActive(): boolean {
    return this.selectedType !== null && this.selectedType !== "";
  }

  doesFilterPass(params: any): boolean {
    if (!this.selectedType || this.selectedType === "") {
      return true;
    }
    return params.data.type === this.selectedType;
  }

  getModel(): any {
    return this.selectedType && this.selectedType !== "" ? this.selectedType : null;
  }

  setModel(model: any): void {
    if (model && typeof model === "string") {
      this.selectedType = model;
    } else {
      this.selectedType = ""; // 设置为空字符串表示"全部"
    }

    // 更新UI
    const radios = this.eGui?.querySelectorAll('input[type="radio"][name="type-filter"]') || [];
    radios.forEach((radio) => {
      const input = radio as HTMLInputElement;
      input.checked = input.value === (this.selectedType || "");
    });
  }

  destroy(): void {
    this.isInitialized = false;
  }
}

export default CustomTypeFilterComponent;
